document.addEventListener('DOMContentLoaded', () => {
    const mobile_max = 768;
    const swipe_threshold = 50;
    const swipe_activate_delta = 10;

    const containers = document.querySelectorAll('.collage-slider, [data-slider-on-mobile]');

    containers.forEach((container) => {
        const isCollageSlider = container.classList.contains('collage-slider');
        const sliderOnMobileAttr = container.getAttribute('data-slider-on-mobile');
        const sliderOnMobile = sliderOnMobileAttr === 'true' || (isCollageSlider && container.dataset.sliderOnMobile === 'true');

        let slider = container.querySelector('.collage-slider-wrapper');
        let items  = slider ? slider.querySelectorAll('.collage__item') : [];
        let itemCount = items.length;

        const prevButton = container.querySelector('.slider-prev, .slider-button--prev');
        const nextButton = container.querySelector('.slider-next, .slider-button--next');
        const sliderControls = container.querySelector('.slider-controls-container, .slider-buttons');
        const sliderCounter  = container.querySelector('.slider-counter');

        let currentIndex = 0;
        let sliderRemoved = false;
        let listenersAttached = false;

        let touchStartX = 0;
        let touchStartY = 0;
        let touchCurrentX = 0;
        let isDragging = false;
        let isHorizontal = false;
        let startTime = 0;
        let lastX = 0;
        let velocityX = 0;

        function ensureSliderRefs() {
            slider = container.querySelector('.collage-slider-wrapper');
            items  = slider ? slider.querySelectorAll('.collage__item') : [];
            itemCount = items.length;
        }

        function updateCounter() {
            if (!sliderCounter || itemCount === 0) return;
            sliderCounter.textContent = `${currentIndex + 1}/${itemCount}`;
        }

        function getSliderWidth() {
            return slider ? slider.parentElement.offsetWidth : 0;
        }

        function getItemWidth() {
            const width = getSliderWidth();
            return width;
        }

        function getCurrentTranslate() {
            return -currentIndex * getItemWidth();
        }

        function setPosition(translate, animate = false) {
            if (!slider) return;
            
            if (animate) {
                slider.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            } else {
                slider.style.transition = 'none';
            }
            
            slider.style.transform = `translateX(${translate}px)`;
        }

        function goToSlide(index, animate = true) {
            if (!slider || itemCount === 0) return;
            currentIndex = Math.max(0, Math.min(itemCount - 1, index));
            const targetTranslate = getCurrentTranslate();
            setPosition(targetTranslate, animate);
            updateCounter();
        }

        function onTouchStart(e) {
            if (!slider) return;
            
            const touch = e.touches[0];
            touchStartX = touch.clientX;
            touchStartY = touch.clientY;
            touchCurrentX = touch.clientX;
            lastX = touch.clientX;
            
            isDragging = true;
            isHorizontal = false;
            startTime = Date.now();
            velocityX = 0;
            
            slider.style.transition = 'none';
        }

        function onTouchMove(e) {
            if (!isDragging || !slider) return;
            
            const touch = e.touches[0];
            const currentX = touch.clientX;
            const currentY = touch.clientY;
            const deltaX = currentX - touchStartX;
            const deltaY = currentY - touchStartY;
            
            if (!isHorizontal && Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > swipe_activate_delta) {
                isHorizontal = true;
            }
            
            if (isHorizontal) {
                if (e.cancelable) {
                    e.preventDefault();
                }
                
                const timeDelta = Date.now() - startTime;
                if (timeDelta > 0) {
                    velocityX = (currentX - lastX) / timeDelta * 16;
                }
                lastX = currentX;
                startTime = Date.now();
                
                const baseTranslate = getCurrentTranslate();
                let newTranslate = baseTranslate + deltaX;
                
                const itemWidth = getItemWidth();
                const maxTranslate = 0;
                const minTranslate = -(itemCount - 1) * itemWidth;
                
                if (newTranslate > maxTranslate) {
                    const overflow = newTranslate - maxTranslate;
                    newTranslate = maxTranslate + overflow * 0.3;
                } else if (newTranslate < minTranslate) {
                    const overflow = minTranslate - newTranslate;
                    newTranslate = minTranslate - overflow * 0.3;
                }
                
                setPosition(newTranslate, false);
                touchCurrentX = currentX;
            }
        }

        function onTouchEnd(e) {
            if (!isDragging) return;
            
            isDragging = false;
            
            if (isHorizontal && slider) {
                const deltaX = touchCurrentX - touchStartX;
                const itemWidth = getItemWidth();
                                
                let newIndex = currentIndex;
                
                if (Math.abs(velocityX) > 0.5) {
                    if (velocityX > 0) {
                        newIndex = currentIndex - 1;
                    } else {
                        newIndex = currentIndex + 1;
                    }
                } else if (Math.abs(deltaX) > swipe_threshold) {
                    if (deltaX > 0) {
                        newIndex = currentIndex - 1;
                    } else {
                        newIndex = currentIndex + 1;
                    }
                }
                
                goToSlide(newIndex, true);
            }
            
            isHorizontal = false;
        }

        function attachSwipe() {
            if (!slider) return;
            slider.addEventListener('touchstart', onTouchStart, { passive: true });
            slider.addEventListener('touchmove', onTouchMove, { passive: false });
            slider.addEventListener('touchend', onTouchEnd, { passive: true });
            slider.addEventListener('touchcancel', onTouchEnd, { passive: true });
        }

        function detachSwipe() {
            if (!slider) return;
            slider.removeEventListener('touchstart', onTouchStart);
            slider.removeEventListener('touchmove', onTouchMove);
            slider.removeEventListener('touchend', onTouchEnd);
            slider.removeEventListener('touchcancel', onTouchEnd);
        }

        function onPrev() {
            goToSlide(currentIndex - 1, true);
        }

        function onNext() {
            goToSlide(currentIndex + 1, true);
        }

        function detachNavListeners() {
            if (!listenersAttached) return;
            if (prevButton) prevButton.removeEventListener('click', onPrev);
            if (nextButton) nextButton.removeEventListener('click', onNext);
            listenersAttached = false;
        }

        function attachNavListeners() {
            if (listenersAttached) return;
            if (prevButton) prevButton.addEventListener('click', onPrev);
            if (nextButton) nextButton.addEventListener('click', onNext);
            listenersAttached = true;
        }

        function mountMobile() {
            ensureSliderRefs();

            if (isCollageSlider && sliderRemoved) {
                container.appendChild(slider);
                sliderRemoved = false;
            }

            if (sliderControls) sliderControls.style.display = 'flex';

            currentIndex = 0;
            goToSlide(0, false);
            updateCounter();
            attachNavListeners();
            attachSwipe();
        }

        function unmountDesktop() {
            detachNavListeners();
            detachSwipe();

            if (slider) {
                slider.style.transform = '';
                slider.style.transition = '';
            }
            if (sliderCounter) {
                sliderCounter.textContent = '';
            }

            if (isCollageSlider && slider && !sliderRemoved) {
                const parent = slider.parentNode;
                while (slider.firstChild) parent.insertBefore(slider.firstChild, slider);
                parent.removeChild(slider);
                sliderRemoved = true;
            }

            const ds = container.getAttribute('data-slider-on-mobile');
            if (ds === 'false' && sliderControls) {
                sliderControls.style.display = 'none';
            }
        }

        function setup() {
            const isMobile = window.innerWidth <= mobile_max;
            if (isMobile && sliderOnMobile) {
                mountMobile();
            } else {
                unmountDesktop();
            }
        }

        setup();
        window.addEventListener('resize', setup);
    });
});